'use client'

import { LazyMotion, domAnimation, m, useScroll, useReducedMotion } from 'framer-motion'

// Scroll-linked reading-progress rail for /blog/[slug] article views.
// A thin lime bar pinned above the header that fills left → right as the
// reader moves through the page. Transform-only (scaleX driven straight
// off useScroll, no spring smoothing, no layout work) so it never
// repaints the page. Under prefers-reduced-motion the rail is dropped
// entirely; the reader just gets the article.

export function ReadingProgress() {
  const { scrollYProgress } = useScroll()
  const reduce = useReducedMotion()
  if (reduce) return null
  return (
    <LazyMotion features={domAnimation}>
      <m.div
        aria-hidden
        className="fixed inset-x-0 top-0 z-50 h-1 origin-left bg-primary print:hidden"
        style={{ scaleX: scrollYProgress }}
      />
    </LazyMotion>
  )
}
